/* eslint-disable max-len */
import {
  CitizenStatus,
  EmploymentStatus,
} from '@modules/opportunities/entities/opportunity/opportunity.entity';
import { useTranslation } from 'react-i18next';
import editableTemplateStyles from '@modules/proposals/presentation/v2/pages/ProposalCreation/es/views/EditableTemplate/styles';
import { mapToTranslationKey } from '@modules/proposals/presentation/utils';
import { Flex, Text } from '@huspy/briks-web';

type Props = {
  employmentStatus: EmploymentStatus;
  citizenStatus: CitizenStatus;
};

export const FinancialRequirements = ({
  employmentStatus,
  citizenStatus,
}: Props) => {
  const { t } = useTranslation();
  return (
    <>
      <Flex w='200px' bg='black' p='2' justify='center'>
        <Text color='white' size='md'>
          {t('proposals.template.financial_details.title')}
        </Text>
      </Flex>
      <table>
        <thead>
          <tr>
            <th className={ editableTemplateStyles.financialTableCellHead }>
              {t('common.forms.employmentStatus.label')}
            </th>
            <th className={ editableTemplateStyles.financialTableCellHead }>
              {t('common.forms.residencyStatus.label')}
            </th>
            <th className={ editableTemplateStyles.financialTableCellHead }>
              {t('common.forms.mortgageType.label')}
            </th>
            <th className={ editableTemplateStyles.financialTableCellHead }>
              {t('common.forms.commission.label')}
            </th>
            <th className={ editableTemplateStyles.financialTableCellHead }>
              {t('common.forms.transactionType.label')}
            </th>
            <th className={ editableTemplateStyles.financialTableCellHead }>
              {t('common.forms.mortgageTerm.label')}
            </th>
            <th className={ editableTemplateStyles.financialTableCellHead }>
              {t('common.forms.state.label')}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td
              className={ editableTemplateStyles.financialTableCellData }
              contentEditable
              suppressContentEditableWarning
            >
              {t(mapToTranslationKey(employmentStatus)) ?? ''}
            </td>
            <td
              className={ editableTemplateStyles.financialTableCellData }
              contentEditable
              suppressContentEditableWarning
            >
              {t(mapToTranslationKey(citizenStatus)) ?? ''}
            </td>
            <td
              className={ editableTemplateStyles.financialTableCellData }
              contentEditable
              suppressContentEditableWarning
              aria-label='field'
            />
            <td
              className={ editableTemplateStyles.financialTableCellData }
              contentEditable
              suppressContentEditableWarning
              aria-label='field'
            />
            <td
              className={ editableTemplateStyles.financialTableCellData }
              contentEditable
              suppressContentEditableWarning
              aria-label='field'
            />
            <td
              className={ editableTemplateStyles.financialTableCellData }
              contentEditable
              suppressContentEditableWarning
              aria-label='field'
            />
            <td
              className={ editableTemplateStyles.financialTableCellData }
              contentEditable
              suppressContentEditableWarning
              aria-label='field'
            />
          </tr>
        </tbody>
      </table>
    </>
  );
};
